import React, { useState } from 'react';
import Modals from '../Modals';
import { Button, InputField } from 'components/Global';
import { useAppContext } from 'components/Context/AppContext';
import { ReactComponent as ZoneFilledIcon } from 'icons/zone-filled-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { addNewZoneType, editZoneTypeById, getAllZoneType, getZoneTypeDetailById } from 'features/zone/actions';
import { checkEmptyObject } from 'utils/functionality';
import { resetZoneTypeSelected } from 'features/zone/zoneTypeSlice';
import { trackEvent } from 'utils/analytics';

const AddZoneTypeModal = ({ showModal, setShowModal }) => {
  const dispatch = useDispatch();
  const { showToast } = useAppContext();
  const [data, setData] = useState({
    name: '',
  });
  const zoneTypeData = useSelector((state) => state.zoneType.selected);

  const confirmationHandler = async (e) => {
    e.preventDefault();

    if (data.name.trim() === '') {
      showToast({ type: 'warning', message: 'Harap isi nama tipe daerah' });
      return;
    }

    try {
      if (showModal.id) {
        trackEvent('zone_type_updated', { zone_type_id: showModal.id, source: 'zone_type_modal' });
        await dispatch(editZoneTypeById({ payload: data, id: showModal.id }));
        showToast({ type: 'success', message: 'Berhasil mengubah data tipe daerah zona' });
      } else {
        trackEvent('zone_type_created', { source: 'zone_type_modal' });
        await dispatch(addNewZoneType(data)).unwrap();
        showToast({ type: 'success', message: 'Berhasil menambah data tipe daerah zona' });
      }
    } catch (error) {
      if (showModal.id) {
        showToast({ type: 'error', message: 'Gagal mengubah data tipe daerah zona' });
      } else {
        showToast({ type: 'error', message: 'Gagal menambah data tipe daerah zona' });
      }
    } finally {
      setShowModal({ show: false, id: 0 });
      dispatch(getAllZoneType({ page: 1 }));
    }
  };

  const backHandler = () => {
    setShowModal({ show: false, id: 0 });
    setData({
      name: '',
    });
    dispatch(resetZoneTypeSelected());
  };

  useEffect(() => {
    if (checkEmptyObject(zoneTypeData)) return;
    setData(zoneTypeData);
  }, [zoneTypeData]);

  useEffect(() => {
    if (!showModal.id) return;
    dispatch(getZoneTypeDetailById(showModal.id));
  }, [dispatch, showModal.id]);

  return (
    <Modals
      setState={backHandler}
      icon={<ZoneFilledIcon fill="#009EF7" width="25px" height="25px" />}
      title={showModal.id ? 'Edit Tipe Daerah' : 'Tambah Tipe Daerah'}
    >
      <form className="add-zone-type-modal" onSubmit={confirmationHandler}>
        <InputField
          value={data.name}
          label="Nama Tipe Daerah"
          placeholder="Ketik Nama Tipe Daerah "
          className="add-zone-type-modal__region-name"
          onChange={(e) => setData((prev) => ({ ...prev, name: e.target.value }))}
        />

        <div className="add-zone-type-modal__buttons">
          <Button height={40} width={192} variant="outline" onClick={backHandler}>
            Kembali
          </Button>
          <Button height={40} width={192} type="submit">
            {showModal.id ? 'Simpan' : 'Tambah'}
          </Button>
        </div>
      </form>
    </Modals>
  );
};

export default AddZoneTypeModal;
